import i18n from 'i18next';
import { useSelector } from 'react-redux';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetCarrierList } from '../../hooks/use-get-carrier-list';

export const CarrierSelect = ({
  placeholder = i18n.t('translation:default.fields.shipmentBranch.label'),
  label = i18n.t('translation:default.fields.shipmentBranch.label'),
  rules = [],
  name,
  editMode,
  margin,
  disabled,
  onChange = undefined,
}) => {
  const { selectedCompany } = useSelector((state) => state.auth);
  const { data: options = [], isLoading } = useGetCarrierList({ customerKey: selectedCompany.companyId });

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      rules={rules}
      name={name}
      editMode={editMode}
      margin={margin}
      disabled={disabled}
      onChange={onChange}
    />
  );
};
